// Canonical production domain. Hardcoded so SEO canonicals, og:url, and sitemap
// always point to the live custom domain regardless of which environment a
// visitor is currently viewing. Internal runtime URLs (analytics referrer
// filtering, etc.) can still use window.location.origin where needed.
const CANONICAL_DOMAIN = "https://blackrdg.com";

export const SITE = {
  name: "Black Ridge Construction",
  shortName: "Black Ridge",
  phone: "254-221-9870",
  phoneE164: "+12542219870",
  email: "Matthew@blackrdg.com",
  domain: CANONICAL_DOMAIN,
  canonicalDomain: CANONICAL_DOMAIN,
  tagline: "Austin's Full-Service Construction, Roofing & Home Maintenance Partner",
  description:
    "Black Ridge Construction is a full-service residential general contractor serving Austin and Central Texas. Roofing, remodeling, home additions, outdoor living, repairs, and ongoing maintenance memberships under one trusted team.",
  defaultTitle:
    "Black Ridge Construction | Austin TX General Contractor & Roofing",
  serviceArea: "Austin, TX & Central Texas",
  logo: "https://customer-assets.emergentagent.com/job_ridge-roofing-austin/artifacts/2iuwgelr_FullLogo_Transparent.png",
};

export const TIMELINE_OPTIONS = [
  "As soon as possible",
  "Within 30 days",
  "1-3 months",
  "3-6 months",
  "Just exploring",
];

export const SERVICE_OPTIONS = [
  "Roofing",
  "Roof Repair",
  "Roof Replacement",
  "Kitchen Remodel",
  "Bathroom Remodel",
  "Full Home Remodel",
  "Home Addition",
  "ADU / Garage Conversion",
  "Outdoor Living / Patio / Deck",
  "Exterior Repairs / Siding",
  "Drywall / Painting",
  "Flooring",
  "Windows / Doors",
  "Fence / Gate",
  "Maintenance Membership",
  "Repair / Punch List",
  "Investor / Make-Ready",
  "Other",
];

export const CONTACT_METHODS = ["Phone", "Text", "Email"];

export const BUDGET_OPTIONS = [
  "Under $5,000",
  "$5,000 - $15,000",
  "$15,000 - $40,000",
  "$40,000 - $100,000",
  "$100,000+",
  "Not sure yet",
];
